(function(window, scormConstantsFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.scormConstants = scormConstantsFactory();
})(this, function() {
   'use strict';

   return Object.freeze({
      fn: {
         initialize: 'initialize',
         terminate: 'terminate',
         getValue: 'getValue',
         setValue: 'setValue',
         commit: 'commit',
         getLastError: 'getLastError',
         getErrorString: 'getErrorString',
         getDiagnostic: 'getDiagnostic'
      },
      dataModelID: {
         cmiExit: 'cmiExit',
         cmiLocation: 'cmiLocation',
         cmiSuspendData: 'cmiSuspendData',
         cmiProgressMeasure: 'cmiProgressMeasure',
         cmiScaledPassingScore: 'cmiScaledPassingScore',
         cmiScoreMin: 'cmiScoreMin',
         cmiScoreMax: 'cmiScoreMax',
         cmiScoreRaw: 'cmiScoreRaw',
         cmiScoreScaled: 'cmiScoreScaled',
         cmiSuccessStatus: 'cmiSuccessStatus',
         cmiCompletionStatus: 'cmiCompletionStatus'
      },
      scorm1Dot2DataModel: {
         cmiExit: 'cmi.core.exit',
         cmiLocation: 'cmi.core.lesson_location',
         cmiSuspendData: 'cmi.suspend_data',
         cmiProgressMeasure: null,
         cmiScaledPassingScore: 'cmi.student_data.mastery_score',
         cmiScoreMin: 'cmi.core.score.min',
         cmiScoreMax: 'cmi.core.score.max',
         cmiScoreRaw: 'cmi.core.score.raw',
         cmiScoreScaled: 'cmi.core.score.scaled',
         cmiSuccessStatus: null,
         cmiCompletionStatus: 'cmi.core.lesson_status'
      },
      scorm2004DataModel: {
         cmiExit: 'cmi.exit',
         cmiLocation: 'cmi.location',
         cmiSuspendData: 'cmi.suspend_data',
         cmiProgressMeasure: 'cmi.progress_measure',
         cmiScaledPassingScore: 'cmi.scaled_passing_score',
         cmiScoreMin: 'cmi.score.min',
         cmiScoreMax: 'cmi.score.max',
         cmiScoreRaw: 'cmi.score.raw',
         cmiScoreScaled: 'cmi.score.scaled',
         cmiSuccessStatus: 'cmi.success_status',
         cmiCompletionStatus: 'cmi.completion_status'
      },
      status: {
         completed: 'completed',
         incomplete: 'incomplete',
         notAttempted: 'not attempted',
         unknown: 'unknown',
         passed: 'passed',
         failed: 'failed',
         browsed: 'browsed'
      },
      exitStates: {
         complete: '',
         suspend: 'suspend'
      },
      versions: {
         NOT_DETECTED: -1,
         SCORM_1_2: 0,
         SCORM_2004: 1
      }
   });
});

